import { validatePattern } from './validation'
import { debouncer } from './debouncer'

export function reloadOnBackPress() {
    window.addEventListener("pageshow", function (event) {
        const entries = performance.getEntriesByType("navigation") as PerformanceNavigationTiming[];

        const historyTraversal = event.persisted || (entries.length > 0 && entries[0].type === "back_forward");

        if (historyTraversal) {
            // Handle page restore.
            window.location.reload();
        } else {
            document.querySelectorAll('.form-container.invisible').forEach((el) => {
                el.classList.remove('invisible');
            });
        }
    });
}

export function setHiddenAttribute (elem: HTMLElement, setHidden = true) {
    if (setHidden) {
        elem.setAttribute("hidden", "hidden");
        return;
    }

    elem.removeAttribute("hidden");
}

export function customHtml5PatternValidation (form: HTMLFormElement) {
    const inputEvent = new Event('input');
    const updateFormState = (event: Event) => {
        const input: HTMLInputElement = event.target as HTMLInputElement;
        validatePattern(input);
    }

    const validateInput = (event: Event) => {
        debouncer(() => {
            updateFormState(event);
        })
    };

    if(form){
        form.querySelectorAll('input[pattern][title]')?.forEach((elem) => {
            const title = elem.getAttribute('title');
            if (title === null || `${title}`.length === 0) {
                return;
            }
            elem.setAttribute('data-pattern', elem.getAttribute('pattern'));
            elem.removeAttribute('pattern');
    
            elem.addEventListener("input", validateInput);
    
            elem.dispatchEvent(inputEvent);
        });
    }    
}

export function cloneBankToClaimDetails (form: HTMLFormElement) {
    const input = form.querySelector<HTMLInputElement>('#ClaimSameAsBank');
    const updateFormState = () => {
        if (input.checked) {
            form.querySelectorAll<HTMLInputElement>('[data-clone-from]')?.forEach((cloneFromElement) => {
                const field = cloneFromElement.getAttribute('data-clone-from');
                form.querySelectorAll<HTMLInputElement>(`[data-clone-to="${field}"]`)?.forEach((cloneToElement) => {
                    cloneToElement.value = cloneFromElement.value;
                    validatePattern(cloneToElement);
                })
            })
        }
    };

    input.addEventListener("change", updateFormState);
}